import { useInsertEntityReferencesMutation } from '@crew/apis/entityReference/entityReferenceApis'
import { useGenerateRelatedMutation } from '@crew/apis/crossSearch/crossSearchApis'
import { EntityReferenceType, EntityType } from '@crew/enums/domain'
import { EntityReference } from '@crew/models/domain'
import { NotifyEventType } from 'enums/app'
import {
  ObjectEventMessage,
  notifyEntityReferencesEvent,
} from 'features/app/states/appSlice'
import { useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { useAppDispatch } from 'states/hooks'
import { SuggestionItem } from '../../eventDetailRelatedInfoList'

export const useEventDetailRelatedInfoListToolbar = () => {
  const dispatch = useAppDispatch()
  const { eventId } = useParams()

  // 会議関連情報生成API
  const [
    generateRelatedMutation,
    { isLoading: isLoadingGenerateRelatedMutation },
  ] = useGenerateRelatedMutation()
  // エンティティ参照登録API
  const [
    insertEntityReferencesMutation,
    { isLoading: isLoadingInsertEntityReferencesMutation },
  ] = useInsertEntityReferencesMutation()

  // 関連提案生成
  const generateEventRelatedInfo = useCallback(async () => {
    if (!eventId) {
      throw new Error('eventId is undefined')
    }

    await generateRelatedMutation({
      entityType: EntityType.Event,
      entityRecordId: eventId,
    }).unwrap()
  }, [generateRelatedMutation, eventId])

  // 関連情報登録
  const insertEntityReferences = useCallback(
    async (data: SuggestionItem[]) => {
      // eventIdが存在しないと正しく処理できないのでエラーを投げる
      if (!eventId) {
        throw new Error('eventId is undefined')
      }

      // 関連情報が0件の場合は登録処理を行わない
      if (data.length === 0) {
        return
      }

      await insertEntityReferencesMutation({
        referenceType: EntityReferenceType.RelatedEvents,
        sourceEntityType: EntityType.Event,
        sourceEntityRecordId: eventId,
        destinationEntityReferences: data,
      }).unwrap()

      const objectEventMessage: ObjectEventMessage<EntityReference> = {
        eventType: NotifyEventType.Inserted,
        id: '',
        object: undefined,
      }
      dispatch(notifyEntityReferencesEvent(objectEventMessage))
    },
    [dispatch, insertEntityReferencesMutation, eventId]
  )

  return {
    insertEntityReferences,
    isLoadingInsertEntityReferencesMutation,
    generateEventRelatedInfo,
    isLoadingGenerateRelatedMutation,
  }
}
